export default "__VITE_ASSET__keIbOTKl__"